"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
// Relements
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var react_portal_1 = require("react-portal");
// Constants
var constants_1 = require("./constants");
var OverlayWrapper = styled_components_1["default"](box_1["default"])({
    position: 'fixed',
    top: 0,
    left: 0,
    padding: '0px',
    width: '100vw',
    height: '100%',
    zIndex: 2,
    overflow: 'hidden',
    pointerEvents: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
});
var Wrapper = styled_components_1["default"](box_1["default"])(function (props) { return ({
    position: 'absolute',
    width: 248,
    padding: 16,
    columnGap: 12,
    alignItems: 'center',
    flexDirection: 'column',
    bottom: '74px',
    background: props.theme.colors.grey.pastel,
    border: "1px solid " + props.theme.colors.grey.haptik,
    borderRadius: props.theme.radii.sm,
    boxShadow: "0px 2px 9px " + props.theme.colors.text + "17",
}); });
var ContentWrapper = styled_components_1["default"](box_1["default"])({
    padding: 0,
    width: '100%',
    columnGap: 12,
    alignItems: 'center',
});
var VerticalSeparatorLine = styled_components_1["default"]('div')(function (props) { return ({
    border: "0.5px solid " + props.theme.colors.grey.neon,
    height: 20,
}); });
var HorizontalSeparatorLine = styled_components_1["default"]('div')(function (props) { return ({
    border: "0.5px solid " + props.theme.colors.grey.neon,
    width: '100%',
    margin: '16px 0px',
}); });
var KeyboardShortcuts = function (_a) {
    var toggleKeyboardShortcuts = _a.toggleKeyboardShortcuts;
    var contentRef = react_1.useRef();
    var onOverlayClick = function (event) {
        if (contentRef.current && !contentRef.current.contains(event.target)) {
            toggleKeyboardShortcuts();
        }
    };
    return (react_1["default"].createElement(react_portal_1.Portal, null,
        react_1["default"].createElement(OverlayWrapper, { onClick: onOverlayClick },
            react_1["default"].createElement(Wrapper, { ref: contentRef }, constants_1.KEYBOARD_SHORTCUTS_LIST.map(function (shortcut) { return (react_1["default"].createElement(react_1["default"].Fragment, null,
                react_1["default"].createElement(ContentWrapper, null,
                    shortcut.icon,
                    react_1["default"].createElement(VerticalSeparatorLine, null),
                    react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column" },
                        react_1["default"].createElement(text_1["default"], { variant: "h4.semi-bold" }, shortcut.title),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md" }, shortcut.subtitle))),
                shortcut.separator && react_1["default"].createElement(HorizontalSeparatorLine, null))); })))));
};
exports["default"] = KeyboardShortcuts;
